import React from 'react';
import { Icon, Popup, Table } from 'semantic-ui-react';
import errorConverter from '../../../Services/ErrorConverter';
import './Style.css';

interface IRowProps {
    dateTime: string;
    message?: string;
    isSuccess?: boolean;
    inProgress?: boolean;
    productCount: number;
}

function LogDescription(props: {
    positive: undefined | boolean,
    loading: boolean | undefined,
    message: string | undefined
}) {
    return <Table.Cell>
        {props.positive ?
            <div>
                <Icon loading={props.loading} name={props.loading ? "spinner" : "checkmark"}/>
            </div>
            :
            <Popup
                trigger={
                    <div style={{"cursor": "pointer"}}>
                        <Icon name="close"/>
                    </div>
                }
                content={errorConverter.getCaptionFormCode(props.message!)}
                position="right center"
            />
        }
    </Table.Cell>;
}

export function LogRow(props: IRowProps) {
    const {isSuccess, inProgress, productCount } = props;
    const positive = isSuccess || inProgress;
    let className = positive ? "positive-row" : "negative-row";
    
    return (
        <Table.Row className={className}>
            <Table.Cell>{props.dateTime ?? '-'}</Table.Cell>
            <LogDescription 
                positive={positive} 
                loading={inProgress} 
                message={props.message}
            />
            <Table.Cell>{productCount}</Table.Cell>
        </Table.Row>
    );
}